module.exports = __webpack_public_path__ + "static/media/Phione_gaussian2.b36b3239.png";